class JobsearchcardController {
  constructor($timeout) {
    this.name = "jobsearchcard";

    this.$timeout = $timeout;
  }

  $onInit() {
    this.$timeout(() => {
      this.$timeout(() => {
        $(".app-status-icon").tooltip({});
      }, 200);
    });
  }
}

JobsearchcardController.$inject = ["$timeout"];

export default JobsearchcardController;



// WEBPACK FOOTER //
// ./client/app/common/jobsearchcard/jobsearchcard.controller.js